import { styled , useTheme } from '@mui/material/styles'
import { useState, useEffect } from 'react'

import { ReactComponent as SasaviSvgDarkLogo } from '../assets/logoipsum-sasavi-logo-dark.svg'
import { ReactComponent as SasaviSvgLogo } from '../assets/logoipsum-sasavi-logo.svg'
import { useRefreshSignal } from '../contexts/refreshSignal'
import { useBusinessLogic } from '../hooks/useBusinessLogic'

// import { useUpdateItem } from '../hooks/useUpdateItem'
import { AddSasaviForm } from './forms/AddSasaviForm'
import { Items } from './Items'
import NavBar from './NavBar'

/**
 * This sets a container at the bottom of the page
 */
const OverlayBottomContainerTODO = styled('div')(({ theme }) => ({
  paddingTop: '0.5rem',
  paddingBottom: '1rem',
  // marginBottom: '1rem',
  position: 'fixed',
  bottom: '0',
  left: 0,
  width: '100%',
  height: '4rem',
  zIndex: 1000,
  backgroundColor: theme.palette.background.default,
  background: theme.palette.mode === 'dark' ? 'linear-gradient(to bottom, rgba(224,224,224,0) 30%, black 80%)' : 'linear-gradient(to bottom, rgba(224,224,224,0) 30%, #e0e0e0 80%)'
  // background: 'linear-gradient(to bottom, rgba(224,224,224,0) 30%, #e0e0e0 80%)'
  // Add other styling properties as needed
}))

// Centered logo container
const LogoContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginTop: '1rem',
  marginBottom: '1rem'
}))

const Container = styled('div')(() => ({
  display: 'flex',
  // minHeight: '100vh',
  flexDirection: 'column',
  position: 'relative' // Add position relative for positioning FeedItemForm
}))

const Main = () => {
  const theme = useTheme()
  const [items, setItems] = useState([])
  const { fetchItemsDb, createItem } = useBusinessLogic()
  const [isFilterByLiked, setFilterLiked] = useState(false)
  // const { itemToUpdate, setUpdateItem } = useUpdateItem()
  const { refreshTrigger } = useRefreshSignal()
  const [showAddSasaviForm, setShowAddSasaviForm] = useState(false)
  useEffect(() => {
    fetchItemsDb(isFilterByLiked).then(setItems)
  }, [fetchItemsDb, isFilterByLiked])

  // Listen for refresh signals
  useEffect(() => {
    if (refreshTrigger > 0) {
      fetchItemsDb(isFilterByLiked).then(setItems)
    }
  }, [refreshTrigger, fetchItemsDb, isFilterByLiked])

  return (
    <Container id="app">
      <LogoContainer>
        <a href='/'>
          {theme.palette.mode === 'dark' ? (
            <SasaviSvgDarkLogo width={200} />
          ) : (
            <SasaviSvgLogo width={200} />
          )}
        </a>
      </LogoContainer>
      <Items items={items} isFilterByLiked={isFilterByLiked}/>
      {showAddSasaviForm && (
        <AddSasaviForm
          createItem={createItem}
          showAddSasaviForm={showAddSasaviForm}
          setShowAddSasaviForm={setShowAddSasaviForm}
          setFilterLiked={setFilterLiked}
        ></AddSasaviForm>
      )}
      <OverlayBottomContainerTODO>
        <NavBar
          isFilterByLiked={isFilterByLiked}
          setFilterLiked={setFilterLiked}
          showAddSasaviForm={() => setShowAddSasaviForm(!showAddSasaviForm)}
        />
      </OverlayBottomContainerTODO>
    </Container>
  )
}

export { Main }
